import { orderBy } from 'lodash-es';
import { OptionGroupDto } from '@/types';
import { SortBy, SortProps } from './SortByDropdown';

export function sortOptionGroups(optionGroups: OptionGroupDto[], sortProps: SortProps): OptionGroupDto[] {
    const { id, direction } = sortProps;

    switch (id) {
        case SortBy.Title:
            return orderBy(optionGroups, [(og) => og.name.toLowerCase()], [direction]);

        case SortBy.Deadline:
            return orderBy(
                optionGroups,
                [(og) => (og.deadline?.deadline ? new Date(og.deadline.deadline) : new Date(9999, 11, 31))],
                [direction]
            );

        default:
            return optionGroups;
    }
}
